import styled from "styled-components";
import { Room as RoomType } from "twilio-video";
import { useLocalParticipant } from "../../hooks/useLocalParticipant";
import { useRemoteParticipant } from "../../hooks/useRemoteParticipant";
import Participant from "./Participant";

const ParticipantListWrapper = styled("div")`
  width: fit-content;
  height: fit-content;
  max-height: 60vh;
  display: flex;
  flex-flow: column;
  justify-content: center;
  box-sizing: border-box;
  position: absolute;
  bottom: 4px;
  right: 12px;
  max-width: 40%;
  gap: 4px;

  @container (max-height: 575px) {
    flex-flow: row;
  }
`;

interface IParticipantListProps {
  room: RoomType;
}

const ParticipantList = ({ room }: IParticipantListProps) => {
  const { localScreenTrack } = useLocalParticipant();
  const { remoteParticipant } = useRemoteParticipant();

  return (
    <ParticipantListWrapper>
      {room && (
        <Participant
          key={room.localParticipant.sid}
          participant={room.localParticipant}
          local={true}
          localScreenTrack={localScreenTrack}
        />
      )}
      {remoteParticipant && (
        <Participant
          key={remoteParticipant.sid}
          participant={remoteParticipant}
          local={false}
        />
      )}
    </ParticipantListWrapper>
  );
};

export default ParticipantList;
